export enum RelatedDocumentAddingMode {
	Local = 'local',
	DM = 'dm',
	All = 'all'
}
